<template>
	<div class="wrapper">
		<div class="box">
			<img src="../../../static/icon_voice.png" />
      <template v-if="isShowFirst">
        <div class="text-box">
          <h3>对练目的：</h3>
          <p>1、熟悉小助手外呼操作步骤；</p>
          <p>2、与搭档进行话术对练；</p>
        </div>
        <div class="text-box">
          <h3>必备条件：</h3>
          <p>1、有对练搭档（一般老师会分组，若未分组，请自行在群内找搭档）；</p>
          <p>2、你的对练搭档也进入了语音对练；</p>
        </div>
        <p class="btn-box">
          <a class="btn" @click="callClick">我已知晓</a>
        </p>
      </template>
			<template v-if="isShowSecond">
        <div class="text-box">
          <h3>请输入对练搭档的9位数淘金号:</h3>
          <el-form :inline="true" :model="add" ref="add" :rules="rules" style="margin-top: 10px;">
            <el-form-item label="" prop="tjkId">
              <el-select filterable remote clearable :remote-method="querySearch" v-model="tjkName" @clear="onClear" @change="onChange" placeholder="输入对练搭档的淘金号" style="width: 320px;">
                <el-option v-for="item in userList" :key="item.id" :label="item.label" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <a class="btn" v-if="!isPending" @click="gotoReady">确认</a>
              <a class="btn" v-else>加载中</a>
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template v-if="isShowThird">
        <div class="text-box">
          <h3>接下来，请按照以下步骤操作：</h3>
          <p>1、点击“待办任务”，并刷新小助手；</p>
          <p>2、完成打卡；</p>
          <p>3、签入SIP话机；</p>
          <p>4、领取数据；</p>
          <p>5、进行外呼练习，并填写客户资料（对练话术用培训考试给到的话术）；</p>
        </div>
      </template>
    </div>
	</div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      userList: [],
      tjkName: '',
    	add: {
				tjkId: ''
    	},
      isShowFirst: true,
      isShowSecond: false,
      isShowThird: false,
    	isPending: false,
      current: {},
      to: {},
    	rules: {
    		tjkId: [{required: true, message: '请选择用户', trigger: 'blur'}]
    	}
    }
  },
  created() {
  	
  },
  mounted: function () {
  	
  },
  methods: {
    querySearch(queryString) {
      if((queryString !== '') && (queryString.length >= 2)) {
        var data = {
          'tjkParam': queryString
        }
        this.$http.post(API_ROOT.tjkuser + '/tjk/queryForAllType', data).then(response => {
          var result = response.data
          if(result.success) {
            this.userList = result.data.map(this.userWithLabel);
          }else {
            this.$alert(result.msg)
          }
        }, response => {
          this.$alert('网络繁忙，请稍后重试！')
        })
      }
    },
    userWithLabel(user) {
      if( !user ) {
        return user;
      }
      user.label = (user.realName?user.realName:"空")+'('+user.tjkNumber+')';
      return user;
    },
    // 选中
    onChange(item) {
      this.add.tjkId = item;
      this.userList= [];
    },
    onClear() {
      this.add.tjkId = '';
      this.tjkName = '';
      this.userList = [];
    },
    callClick() {
      this.isShowFirst = false;
      this.isShowSecond = true;
    },
    gotoReady() {
    	this.isPending = true;
      this.$http.post(API_ROOT.college +'/voice/exercise/ready', {'tjkId': this.add.tjkId}).then(response=> {
        var result = response.data;
        if(result.success) {
          this.current = result.data.from;
          this.to = result.data.to;
          this.isShowSecond = false;
          this.isShowThird = true;
          this.getHawkeye();
        }else {
          this.$message({
            message: result.msg,
            type: 'error',
            customClass: 'message',
            showClose: true,
            duration: 3000
          })
        }
        this.isPending = false;
      })
    },
    //调用小助手
    getHawkeye() {
      this.$http.get('http://127.0.0.1:26789/api/npg/start').then(response=> {
        var result = response.data;
        if(result.success) {
          
        }
      },response=> {
        
      })
    }
  }
}
</script>

<style lang="less" scoped>
.tj-header {
	display: none;
}
::-webkit-scrollbar {
	display: none;
}
.wrapper {
	width: 100%;
	color: #000000;
	display: -webkit-flex;
  display: flex; 
	height: 100%;
	flex-direction: column;
	background-color: #ffffff;
	align-items: center;
	.btn {
		color: #ffffff;
		height: 36px;
		background: linear-gradient(250deg, #3EABF9, #0A89F1);
		border-radius: 2px;
    font-size: 14px;
    text-align: center;
    line-height: 26px;
    padding: 5px 20px;
    font-weight: bold;
    cursor: pointer;
    display: inline-block;
	}
	.box {
		-webkit-flex: 1;
    -ms-flex: 1; 
    flex: 1;
		width: 100%;
		overflow-y: scroll;
		-webkit-overflow-scrolling: touch;
		height: auto;
		padding: 60px 10px 10px;
		text-align: center;
    .text-box {
      text-align: left;
      width: 480px;
      margin: 10px auto 0;
      line-height: 28px;
    }
		> h3 {
			padding: 20px 0;
		}
		.btn-box {
			margin-top: 20px;
		}
		.person {
			background-color: #F7F7F7;
			padding: 20px;
			> p {
				text-align: left;
				font-size: 16px;
				padding-bottom: 10px;
			}
			.icon {
				display: flex;
        align-items: center;
				> span {
					color: #000000;
					font-weight: bold;
          padding-left: 10px;
				}
			}
		}
		.text {
			margin: 40px 0 20px 0;
		}
		.call-box {
			background-color: #F7F7F7;
			padding: 20px;
			margin-top: 20px;
      font-size: 16px;
      .time {
        font-size: 24px;
        font-weight: bold;
        margin-bottom: 10px;
      }
		}
	}
}
</style>


// WEBPACK FOOTER //
// ./src/page/mobile/voiceExercise.vue